import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=455a1918&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./_header.css?vue&type=style&index=0&id=455a1918&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455a1918",
  null
  
)

export default component.exports